type Props = {
  live: boolean;
};

export default function MappingSessionOverlay({ live }: Props) {
  return (
    <div className="pointer-events-none absolute inset-x-0 top-0 z-40 bg-primary/90 px-3 py-2 text-center">
      <p className="font-sans text-[13px] font-medium leading-snug text-white">
        {live
          ? "We’re signed in as this test user mapping journeys. This isn’t an audit yet — we may click and fill forms."
          : "This was a mapping session: we signed in as the test user to find jobs, not to audit usability."}
      </p>
    </div>
  );
}
